var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "well ovx-auto" },
    [
      _c("div", { staticClass: "flex-level" }, [
        _c("div", { staticClass: "flex fs-4 bold" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$l10n.__("Produits / services issus du catalogue")) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex aright" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.actions.impact_profit"),
                type: "secondary",
                disabled: _vm.impactButtonIsDisable
              },
              on: {
                click: function($event) {
                  return _vm.impact()
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: { data: _vm.rows },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "selection",
              selectable: _vm.canProcess,
              property: "processMargin"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: _vm.$t.__("common.labels.impact_profit") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.displaySaasBoolean(scope.row.processMargin)
                        ) +
                        "\n            "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "name",
              label: _vm.$t.__("common.labels.reference")
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t.__(
                "documents.overview.tab.margin.unit_purchase_amount_exclude_tax"
              )
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm._f("numberformatWithOptions")(
                            scope.row.purchaseAmount,
                            _vm.unitNumberFormat,
                            true
                          )
                        ) +
                        "\n            "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: _vm.$t.__("common.labels.quantity") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("numberformat")(scope.row.qt)) +
                        "\n            "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t.__(
                "documents.overview.tab.margin.Custom.total_purchase_amount_exclude_tax"
              )
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm._f("numberformatWithOptions")(
                            scope.row.totalPurchaseAmount,
                            _vm.docNumberFormat,
                            true
                          )
                        ) +
                        "\n            "
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.rows.length > 0
        ? _c("div", { staticClass: "aright fs-3 mt-2" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$l10n.__("Total impact")) +
                " :\n        " +
                _vm._s(
                  _vm._f("numberformatWithOptions")(
                    _vm.formattedTotal,
                    _vm.docNumberFormat,
                    true
                  )
                ) +
                "\n    "
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }